import { render, staticRenderFns } from "./BlockBreadcrumbs.vue?vue&type=template&id=ba05e358"
import script from "./BlockBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./BlockBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./BlockBreadcrumbs.vue?vue&type=style&index=0&id=ba05e358&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports